import React from "react";
import "./style.css";

import Skeleton from "../Skeleton/Skeleton";

const ArticlePreviewSkeleton = () => (
    <div className="article-preview">
        <Skeleton className="skeleton-image" />
        <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0, justifyContent: "center", gap: "0.5em" }}>
            <Skeleton style={{ height: "1.5em", width: "70%" }} />
            <Skeleton style={{ height: "0.9em", width: "30%" }} />
            <Skeleton style={{ height: "1em", width: "100%" }} />
            <Skeleton style={{ height: "1em", width: "100%" }} />
            <Skeleton style={{ height: "1em", width: "60%" }} />
        </div>
    </div>
);

export default ArticlePreviewSkeleton;
